import React from 'react';
const KettleIcon = () => (
    <svg width="26" height="32" viewBox="0 0 81 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.6372 32.0932C19.8 20.0777 29.8977 10.9099 41.9694 10.9099C53.9456 10.9099 63.9959 19.9375 65.2763 31.845L70.986 84.9453C71.431 89.0836 68.1883 92.6937 64.0261 92.6937H20.4827C16.3503 92.6937 13.1172 89.1326 13.5153 85.0194L18.6372 32.0932Z"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M68.8802 63.8649L65.4817 30.7297H71.1684C73.7354 30.7297 75.8853 32.6736 76.1431 35.2276L78.4783 58.3627C78.7755 61.3077 76.4635 63.8649 73.5035 63.8649H68.8802Z"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M9.96846 95.8919C9.96846 94.2351 11.3116 92.8919 12.9685 92.8919H71.6351C73.292 92.8919 74.6351 94.2351 74.6351 95.8919V99H9.96846V95.8919Z"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect x="21.5811" y="22.5225" width="41.4414" height="1.8018" fill="black" />
        <path
            d="M21.1306 23.4234H10.7703L17.527 39.6396"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect x="13.473" y="81.0811" width="57.6577" height="1.8018" fill="black" />
        <circle
            cx="4.5045"
            cy="4.5045"
            r="3.5045"
            transform="matrix(-1 0 0 1 17.527 9.90991)"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <circle
            cx="3.6036"
            cy="3.6036"
            r="2.6036"
            transform="matrix(-1 0 0 1 9.41891 3.60358)"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <circle
            cx="2.7027"
            cy="2.7027"
            r="1.7027"
            transform="matrix(-1 0 0 1 17.527 1.80182)"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="38.7973"
            y="34.3333"
            width="7.00901"
            height="38.5405"
            rx="3.5045"
            fill="white"
            stroke="#32AE57"
            strokeWidth="2"
        />
        <rect x="41.4009" y="39.6396" width="5.40541" height="1.8018" rx="0.900901" fill="black" />
        <rect x="41.4009" y="50.4504" width="5.40541" height="1.8018" rx="0.900901" fill="black" />
        <rect x="41.4009" y="61.2612" width="5.40541" height="1.8018" rx="0.900901" fill="black" />
        <rect x="43.2027" y="45.045" width="3.6036" height="1.8018" rx="0.900901" fill="black" />
        <rect x="43.2027" y="55.8558" width="3.6036" height="1.8018" rx="0.900901" fill="black" />
        <rect x="43.2027" y="66.6667" width="3.6036" height="1.8018" rx="0.900901" fill="black" />
    </svg>
);

export default KettleIcon;



// WEBPACK FOOTER //
// ./src/components/icons/KettleIcon.js